import React, { useCallback, useEffect, useState } from 'react';
import Loading from '../../../components/loading/Loading';
import { useApolloClient } from '@apollo/client';
import useStyles from './styles';
import {
    PAYMENT_STANCER_URL,
    STANCER_PAYMENT_STATUS,
} from '../../../components/myeirconstant/myEirConstant';
import { Box, Typography } from '@material-ui/core';
import { validateOneOffpayment } from './stancer.util';
import CustomUpdatedPopUpModal from '../../eir-porting/CustomModal/CustomUpdatedPopUpModal';
import errorIcon from '../../../mobilecomponents/images/warning.png';

const {
    FINISHED,
    ERROR,
    PENDING,
    SECURE_AUTH_END,
    SECURE_AUTH_ERROR,
    SECURE_AUTH_START,
    INIT,
    INVALID,
} = STANCER_PAYMENT_STATUS;
/**
 * @name StancerCVCContainer - jsx component for Stancer payment flow
 * @param {object} props - Object containing react props
 * @returns {JSX.Element} - Renders StancerOneOffPaymentContainer component
 */
const StancerCVCContainer = props => {
    const { payableAmount, handleNext, setStatus, setHeader, setPaidAmount, loading, hpp } = props;
    const graphql = useApolloClient();
    const classes = useStyles();
    const [openErrorPopup, setOpenErrorPopup] = useState(false);

    /**
     * @function handleToggleErrorPopup
     * @description Function toggle stancer status error
     */
    const handleToggleErrorPopup = () => {
        setOpenErrorPopup(!openErrorPopup);
    };

    /**
     * @function submitPayment
     * @description Function for submitting add card payemnt using message event handler
     */
    const submitPayment = useCallback(
        event => {
            if (event.origin !== PAYMENT_STANCER_URL) {
                return;
            }
            if (event?.data?.status === PENDING) {
                return;
            }
            if (event?.data?.status === SECURE_AUTH_END) {
                return;
            }
            if (event?.data?.status === SECURE_AUTH_ERROR) {
                return;
            }
            if (event?.data?.status === SECURE_AUTH_START) {
                return;
            }
            if (event?.data?.status === INIT) {
                return;
            }
            if (event?.data?.status === ERROR || event?.data?.status === INVALID) {
                setOpenErrorPopup(true);
            }
            if (event?.data?.status === FINISHED) {
                const paymentId = hpp?.paymentIntentId;
                const checked = false;
                if (paymentId)
                    validateOneOffpayment({
                        graphql,
                        paymentId,
                        payableAmount,
                        setStatus,
                        setPaidAmount,
                        handleNext,
                        checked,
                    });
            }
        },
        [hpp?.paymentIntentId, graphql]
    );

    useEffect(() => {
        window.addEventListener('message', submitPayment, false);
        return () => window.removeEventListener('message', submitPayment);
    }, [submitPayment]);

    useEffect(() => {
        setHeader('Payment summary');
    }, []);

    return (
        <React.Fragment>
            <Box className={classes.PaymentIframeModal}>
                {loading && <Loading />}
                {!loading && hpp && (
                    <>
                        <iframe
                            id='target-iframe'
                            title='stancer-selfcare-one-off-cvc-iframe'
                            frameBorder='0'
                            src={hpp?.url}
                            height={window?.innerWidth <= 768 ? '415px' : '625px'}
                            width={'100%'}
                        />
                    </>
                )}
            </Box>
            {openErrorPopup && (
                <Box id='my-eir-pop-up'>
                    <CustomUpdatedPopUpModal
                        open={openErrorPopup}
                        toggle={handleToggleErrorPopup}
                        cta1={{
                            text: 'Try again',
                            action: () => {
                                setOpenErrorPopup(false);
                            },
                            disable: false,
                        }}
                        cta2={{ text: '', action: () => {} }}
                    >
                        <Box className={classes.successPopup}>
                            <Box className={classes.successImg}>
                                <Typography component='img' src={errorIcon} alt='failure' />
                            </Box>

                            <Typography className={classes.imgTextAdditional}>
                                Sorry something went wrong! Please try again.
                            </Typography>
                        </Box>
                    </CustomUpdatedPopUpModal>
                </Box>
            )}
        </React.Fragment>
    );
};

export default StancerCVCContainer;
